import { Button } from "@similarweb/ui-components";

import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { ShortOpportunityList } from "app/pages/sales-intelligence/modules/lists/types/types";
import { createPluralHelperForI18nKey } from "app/pages/sales-intelligence/utils/strings";

import {
    CUSTOM_MODAL_STYLES,
    StyledModalBody,
    StyledModalContent,
    StyledModalFooter,
    StyledModalSubtitle,
    StyledModalTitle,
} from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/components/SavedSearchDeleteModal/styles";
import { formatNumberOfResults } from "../../../../advanced-search/helpers/common";
import type { OpportunityListType } from "../../../types";
import { OpportunityListTypeEnum } from "../../../types";

import { StyledConfirmationText } from "./styles";

export type ListDeleteModalProps = {
    list?: Readonly<ShortOpportunityList>;
    isOpen: boolean;
    isBeingSubmitted: boolean;
    onCancel(): void;
    onSubmit(id: OpportunityListType["opportunityListId"]): void;
};

const ListDeleteModal = (props: ListDeleteModalProps) => {
    const { list, isOpen, isBeingSubmitted, onCancel, onSubmit } = props;
    const getI18nKey = createPluralHelperForI18nKey("si.static-lists.delete-modal.confirm-websites-amount");

    function handleSubmit(list?: Readonly<ShortOpportunityList>) {
        if (typeof list !== "undefined") {
            onSubmit(list.id);
        }
    }

    return (
        <ProModal
            isOpen={isOpen}
            showCloseIcon={false}
            shouldCloseOnOverlayClick={false}
            customStyles={CUSTOM_MODAL_STYLES}
        >
            <StyledModalContent data-automation="delete-list-modal">
                <StyledModalBody>
                    <I18n
                        element={StyledModalTitle}
                        data-automation="title-text"
                        translatable={{ key: "si.static-lists.delete-modal.title" }}
                    />
                    <StyledModalSubtitle>
                        <StyledConfirmationText
                            data-automation="list-name-delete-confirmation-text"
                            dangerouslySetInnerHTML={{
                                __html: translate("si.static-lists.delete-modal.confirm-name", {
                                    name:
                                        list?.listType === OpportunityListTypeEnum.RecentlyViewed
                                            ? translate("si.opportunity-list.auto-created.title")
                                            : (list?.friendlyName ?? ""),
                                }),
                            }}
                        />
                        <br />
                        <I18n
                            data-automation="websites-amount-delete-confirmation-text"
                            translatable={{
                                key: getI18nKey(list?.totalCount ?? 0),
                                replacements: {
                                    numberOfWebsites: formatNumberOfResults(list?.totalCount ?? 0),
                                },
                            }}
                        />
                    </StyledModalSubtitle>
                </StyledModalBody>
                <StyledModalFooter>
                    <Button
                        type="flatDark"
                        onClick={onCancel}
                    >
                        {translate("si.common.button.cancel")}
                    </Button>
                    <Button
                        type="warning"
                        isLoading={isBeingSubmitted}
                        isDisabled={isBeingSubmitted}
                        onClick={() => handleSubmit(list)}
                    >
                        {translate("si.common.button.delete")}
                    </Button>
                </StyledModalFooter>
            </StyledModalContent>
        </ProModal>
    );
};

export default ListDeleteModal;
